import React, { useState } from 'react';
import { Plus, Trash2, Terminal } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from '../components/ui/dialog';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';

const SSHConnections = () => {
  const [connections, setConnections] = useState([]);
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    host: '',
    port: 22,
    username: '',
    password: ''
  });

  const createConnection = () => {
    setConnections([...connections, { ...formData, id: Date.now().toString(), is_active: true }]);
    toast.success('SSH подключение создано');
    setOpen(false);
    setFormData({ name: '', host: '', port: 22, username: '', password: '' });
  };

  return (
    <div className="h-full overflow-auto p-8" data-testid="ssh-connections-page">
      <div className="flex justify-between items-center mb-8">
        <div>
          <h1 className="text-4xl font-bold text-white mb-2">SSH Подключения</h1>
          <p className="text-gray-400">Управление серверами</p>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild>
            <Button className="bg-gradient-to-r from-blue-600 to-cyan-600" data-testid="add-ssh-btn">
              <Plus className="w-4 h-4 mr-2" />
              Добавить сервер
            </Button>
          </DialogTrigger>
          <DialogContent className="bg-gray-900 border-white/20 text-white">
            <DialogHeader>
              <DialogTitle>Новое SSH подключение</DialogTitle>
              <DialogDescription className="text-gray-400">
                Добавьте сервер для управления
              </DialogDescription>
            </DialogHeader>
            <div className="space-y-4">
              <div>
                <Label>Название</Label>
                <Input
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                  className="bg-white/5 border-white/20 text-white"
                  placeholder="Production Server"
                />
              </div>
              <div>
                <Label>Host</Label>
                <Input
                  value={formData.host}
                  onChange={(e) => setFormData({...formData, host: e.target.value})}
                  className="bg-white/5 border-white/20 text-white"
                  placeholder="192.168.1.1"
                />
              </div>
              <div>
                <Label>Порт</Label>
                <Input
                  type="number"
                  value={formData.port}
                  onChange={(e) => setFormData({...formData, port: parseInt(e.target.value)})}
                  className="bg-white/5 border-white/20 text-white"
                />
              </div>
              <div>
                <Label>Username</Label>
                <Input
                  value={formData.username}
                  onChange={(e) => setFormData({...formData, username: e.target.value})}
                  className="bg-white/5 border-white/20 text-white"
                  placeholder="root"
                />
              </div>
              <div>
                <Label>Пароль</Label>
                <Input
                  type="password"
                  value={formData.password}
                  onChange={(e) => setFormData({...formData, password: e.target.value})}
                  className="bg-white/5 border-white/20 text-white"
                />
              </div>
              <Button onClick={createConnection} className="w-full bg-gradient-to-r from-blue-600 to-cyan-600">
                Добавить
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {connections.map((conn) => (
          <Card key={conn.id} className="glass-panel border-white/10 bg-white/5" data-testid={`ssh-card-${conn.id}`}>
            <CardHeader>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-600 to-cyan-600 flex items-center justify-center">
                  <Terminal className="w-5 h-5 text-white" />
                </div>
                <div>
                  <CardTitle className="text-white">{conn.name}</CardTitle>
                  <CardDescription className="text-gray-400">{conn.host}:{conn.port}</CardDescription>
                </div>
              </div>
            </CardHeader>
            <CardContent>
              <div className="space-y-2 text-sm">
                <div className="flex items-center justify-between">
                  <span className="text-gray-400">Username:</span>
                  <span className="text-white">{conn.username}</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-gray-400">Статус:</span>
                  <span className="flex items-center gap-2">
                    <div className={`w-2 h-2 rounded-full ${conn.is_active ? 'bg-green-500' : 'bg-red-500'}`}></div>
                    <span className="text-white">{conn.is_active ? 'Активен' : 'Не активен'}</span>
                  </span>
                </div>
                <Button
                  variant="destructive"
                  size="sm"
                  className="w-full mt-4"
                  onClick={() => {
                    setConnections(connections.filter(c => c.id !== conn.id));
                    toast.success('SSH подключение удалено');
                  }}
                >
                  <Trash2 className="w-4 h-4 mr-2" />
                  Удалить
                </Button>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default SSHConnections;